import { selectShape, changeShapesPosition, selectShapeFromArea } from '../../actions/CurrentSlideActions';
import storeManager from '../../store/StoreManager';
import shapeTypes from '../../constants/ShapeConstants';
import modeType from '../../constants/ModeConstants';
import platformDetection from './PlatformDetection';
import saveManager from './SaveManager';

const selectionManager = {
    copiedCanvasElement: false,
    currentSlide: undefined,
    isMultipleSelection: false,
    dispatch: undefined,
    initialPositions: [],

    checkControl(event) {
        if (event.ctrlKey == true)
            this.isMultipleSelection = true;
        else
            this.isMultipleSelection = false;
    },
    selectAll() {
        if (this.dispatch)
            this.dispatch(selectShape('selectAll'));
    },
    multipleSelection() {
        if (this.isMultipleSelection == true)
            return true;

        const shapes = storeManager.getState().currentSlide.model.content;
        var i;
        var shape;
        var count = 0;

        for (i=1; i<shapes.length; i++) {
            shape = shapes[i];

            if (shape.isLocked == true)
                continue;

            if (shape.isSelected == true)
                count = count + 1;
        }

        if (count > 1)
            return true;
        else
            return false;
    },
    updateInitialPositions(currentShapeUid) {
        this.initialPositions = [];

        if (this.multipleSelection() == false)
            return;

        const shapes = storeManager.getState().currentSlide.model.content;
        var i;
        var shape;

        for (i=1; i<shapes.length; i++) {
            shape = shapes[i];

            if (shape.isLocked == true)
                continue;

            if (shape.isSelected == true && shape.uuid != currentShapeUid) {
                if (shape.type == shapeTypes.LINE || shape.type == shapeTypes.CURVE) {
                    if (shape.type == shapeTypes.CURVE)
                        this.initialPositions[shape.uuid] = {x1: shape.x1, y1: shape.y1, x2: shape.x2, y2: shape.y2, cx: shape.cx, cy: shape.cy};
                    else
                        this.initialPositions[shape.uuid] = {x1: shape.x1, y1: shape.y1, x2: shape.x2, y2: shape.y2};
                } else {
                    this.initialPositions[shape.uuid] = {x: shape.x, y: shape.y};
                }
            }
        }
    },
    moveShapes(offsetX, offsetY, currentShapeUid) {
        if (this.multipleSelection() == false)
            return;

        const shapes = storeManager.getState().currentSlide.model.content;
        var i;
        var shape;
        var positions = [];
        var isEmpty = true;

        for (i=1; i<shapes.length; i++) {
            shape = shapes[i];

            if (shape.isLocked == true)
                continue;

            if (shape.isSelected == true && shape.uuid != currentShapeUid) {
                var position = this.initialPositions[shape.uuid];

                if (position) {
                    if (shape.type == shapeTypes.LINE || shape.type == shapeTypes.CURVE) {
                        if (shape.type == shapeTypes.LINE)
                            positions[shape.uuid] = {x1: position.x1 + offsetX, y1: position.y1 + offsetY, x2: position.x2 + offsetX, y2: position.y2 + offsetY};
                        else
                            positions[shape.uuid] = {x1: position.x1 + offsetX, y1: position.y1 + offsetY, x2: position.x2 + offsetX, y2: position.y2 + offsetY, cx: position.cx + offsetX, cy: position.cy + offsetY};
                    } else {
                        positions[shape.uuid] = {x: position.x + offsetX, y: position.y + offsetY};
                    }

                    isEmpty = false;
                }
            }
        }

        if (isEmpty == false) {
            this.dispatch(changeShapesPosition(positions));
            saveManager.isContentChanged(true);
        }
    },
    selectShapesFromArea(area) {
        const shapes = storeManager.getState().currentSlide.model.content;
        var i;
        var shape;
        var selection = [];

        for (i=1; i<shapes.length; i++) {
            shape = shapes[i];

            if (shape.type == shapeTypes.LINE || shape.type == shapeTypes.CURVE) {
                if (((shape.x1 >= area.x && shape.x1 <= (area.x + area.width)) || (shape.x2 >= area.x && shape.x2 <= (area.x + area.width))) &&
                    ((shape.y1 >= area.y && shape.y1 <= (area.y + area.height)) || (shape.y2 >= area.y && shape.y2 <= (area.y + area.height)))) {
                    selection.push(shape.uuid);
                }
            } else {
                if (shape.x + shape.width < area.x || area.x + area.width < shape.x || shape.y + shape.height < area.y || area.y + area.height < shape.y)  {
                    // no intersection
                }
                else
                    selection.push(shape.uuid);
            }
        }

        if (shapes.length > 0)
            this.dispatch(selectShapeFromArea(selection));
    },
    getSelectedShapes() {
        const shapes = storeManager.getState().currentSlide.model.content;
        var i;
        var shape;
        var selection = [];

        for (i=1; i<shapes.length; i++) {
            shape = shapes[i];

            if (shape.isSelected == true)
                selection.push(shape.uuid);
        }

        return selection;
    },
    getShapeWithUuid(uuid) {
        const shapes = storeManager.getState().currentSlide.model.content;
        var i;
        var shape;

        for (i=1; i<shapes.length; i++) {
            shape = shapes[i];

            if (shape.uuid == uuid)
                return shape;
        }

        return undefined;
    },
    isTextBoxSelected() {
        var shapes = storeManager.getState().currentSlide.model.content;
        var i;
        var shapeModel;

        for (i=0; i<shapes.length; i++) {
            shapeModel = shapes[i];

            if (shapeModel.isSelected) {
                if (shapeModel.type == shapeTypes.TEXTBOX || shapeModel.type == shapeTypes.TEXTBOXSIMPLE || shapeModel.type == shapeTypes.SPEAK_BUBBLE || shapeModel.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || shapeModel.type == shapeTypes.SCREAM_BUBBLE || shapeModel.type == shapeTypes.THOUGHT_BUBBLE)
                    return true;
            }
        }

        return false;
    },
    isSaveContext() {
        var contextMode = storeManager.getState().menu.contextMode;

        if (contextMode == modeType.SAVE_CONTEXT)
            return true;
        else
            return false;
    },
    checkSelection(uuid) {
        if (uuid == '') {
            this.dispatch(selectShape(uuid));
            return;
        }

        if (this.isMultipleSelection == true)
            return;

        var selection = this.getSelectedShapes();

        if (selection.indexOf(uuid) == -1) {
            if (platformDetection.isIOS())
                document.activeElement.blur();

            this.dispatch(selectShape(''));
        }
    }
};

export default selectionManager;



/** WEBPACK FOOTER **
 ** ./src/components/utils/SelectionManager.js
 **/